'use strict';

import React from 'react';
import ReactDOM from 'react-dom';


export {Stepthree};

class Stepthree extends React.Component {
    constructor(props) {
        super(props);
        this.state = { invalid: [], offert: true }
    }
    componentDidMount() {
        $('.vPhone').inputmask({"mask": "+38 (099) 999 99 99", "cc": "UA", "cd": "Ukraine", "type": "mobile"});
    }

    clearPhone(phone){
        return phone.replace('+38 (', '').replace(/[\(\)\+\s\_]/g, '').substr(-10);
    }

    setOffert(){
        const offert = this.state.offert;
        this.setState({offert: !offert});
    }

    validate(callback){
        let invalid = [];
        if(!document.getElementById('tiName').value){
            invalid.push('name');
        }


        let phone = this.clearPhone($('#tiPhone').val());
        if (!phone || phone.length != 10) {
            invalid.push('phone');
            console.log(phone);
        }

        if (!this.state.offert) {
            invalid.push('offert');
        }

        if(!invalid.length){
            callback();
        }
        this.setState({invalid: invalid});

    }

    render() {
        return (
            <div className={!this.props.active ? 'd-none' : ''}>
                <div className="trade-in-box__mid-form">
                    <div className="row trade-in-box__mid-form__row">
                        <div className="col-md-6">
                            <div className={"form-floating" + (this.state.invalid.indexOf('name') != -1 ? ' has-error' : '')}>
                                <input className="form-control" id="tiName" type="text" name="name" placeholder={lajax.t('Имя')} defaultValue={this.props.customer.name}/>
                                <label htmlFor="tiName">{lajax.t('Имя')}</label>
                                <If condition={this.state.invalid.indexOf('name') != -1}>
                                    <p className="help-block help-block-error">{lajax.t('Это обязательное поле')}</p>
                                </If>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={"form-floating" + (this.state.invalid.indexOf('phone') != -1 ? ' has-error' : '')}>
                                <input className="form-control vPhone" id="tiPhone" type="text" placeholder={lajax.t('Номер телефона')} required="required"  defaultValue={this.props.customer.phone}/>
                                <label htmlFor="tiPhone">{lajax.t('Номер телефона')} </label>
                                <If condition={this.state.invalid.indexOf('phone') != -1}>
                                    <p className="help-block help-block-error">{lajax.t('Это обязательное поле')}</p>
                                </If>
                            </div>
                            <div className="trade-in-box__mid-form__helper">{lajax.t('Номер для связи с менеджером')}</div>
                        </div>
                    </div>
                    <div className="row trade-in-box__mid-form__row">
                        <div className="col-md-6">
                            <div className="trade-in-box__buy-in">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="tiOffert" onChange={() => this.setOffert()} checked={this.state.offert}/>
                                    <label className="form-check-label" htmlFor="tiOffert">{lajax.t('Підтверджуючи заявку, я приймаю умови оферти по ')} <a target="_blank" href={baseUrl + "content/offerta-trade-in.html"}>Trade-In</a></label>
                                    <If condition={this.state.invalid.indexOf('offert') != -1}>
                                        <p className="help-block help-block-error">{lajax.t('Это обязательное поле')}</p>
                                    </If>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="btn btn-lg btn-primary" type="button"
                        onClick={() => this.validate(() => this.props.submit())}
                >{lajax.t('Отправить заявку')}</button>
            </div>
        );
    }
}
